import {
    Component,
    ContentChildren,
    QueryList,
    AfterContentInit,
    Input,
    Output,
    EventEmitter,
    ChangeDetectionStrategy,
} from "@angular/core";
import { Store } from "@ngrx/store";
import { RootState } from "../store/root";
import { Validity } from "../store/validity/state";
import { MainSectionInfo } from "../store/view/state";
import * as View from "../store/view/actions";

@Component({
    selector: "zbd-selector",
    changeDetection: ChangeDetectionStrategy.Default,
    template: ``,
})
export class SelectorComponent {
    @Input() value: string;
    @Input() title: string;
    @Input("long-title") longTitle?: string;
    @Input() validity: Validity;
    @Input() active = false;
    @Input() disabled = false;
    @Input() type: "button" | "link" = "button";
}

@Component({
    selector: "zbd-selector-strip",
    changeDetection: ChangeDetectionStrategy.Default,
    template: `
        <div class="zbd-selector-strip">
            <ng-container *ngFor="let tab of tabs" [ngSwitch]="tab.type">
                <div
                    *ngSwitchCase="'button'"
                    class="zbd-selector zbd-button-like"
                    (click)="!tab.disabled && selectTab(tab)"
                    [class.active]="tab.active"
                >
                    <span class="zbd-left">{{ tab.title }}</span>
                    <span
                        *ngIf="tab.disabled"
                        class="zbd-action-icon icon-loop spinning tracking-action"
                    ></span>
                    <zbd-validity-indicator
                        *ngIf="!tab.disabled"
                        class="zbd-right"
                        [validity]="tab.validity"
                    ></zbd-validity-indicator>
                </div>
                <div
                    *ngSwitchCase="'link'"
                    class="zbd-selector zbd-inline-button"
                    (click)="!tab.disabled && selectTab(tab)"
                    [class.active]="tab.active"
                    [class.unfinished]="!tab.validity.valid"
                >
                    <span class="zbd-left">{{ tab.title }}</span>
                    <span
                        *ngIf="tab.disabled"
                        class="zbd-action-icon icon-loop spinning tracking-action"
                    ></span>
                    <span
                        *ngIf="!tab.disabled"
                        class="icon-icon-cta zbd-right"
                    ></span>
                </div>
            </ng-container>
        </div>
    `,
    styleUrls: ["zbd-selector-strip.component.css"],
})
export class SelectorStripComponent {
    @Input("store-key") storeKey: string;
    @Input() validity: Validity;

    @ContentChildren(SelectorComponent) tabs: QueryList<SelectorComponent>;

    constructor(private store: Store<RootState>) {}

    isTabSelected() {
        let display = false;
        this.tabs.forEach((tab) => (display = tab.active || display));
        return display;
    }

    getSelectedTabIndex() {
        const tabs = this.tabs.toArray();
        for (let index = 0; index < tabs.length; index++) {
            if (tabs[index].active) {
                return index;
            }
        }
        return -1;
    }

    selectTab(tab: SelectorComponent) {
        // deactivate all tabs
        this.tabs.toArray().forEach((tab) => (tab.active = false));

        // activate the tab the user has clicked on.
        tab.active = true;

        const info: MainSectionInfo = {
            key: tab.value,
            label: tab.longTitle || tab.title,
        };
        this.store.dispatch(View.Update.create(this.storeKey as any, info));
    }
}
